import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import { MapaBordero } from './MapaBordero';

function MapaBorderoPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Mapa de Borderôs'));
  return (
    <MapaBordero />
  );
}

export default withTokenInterceptor(MapaBorderoPage);
